module.exports = __webpack_public_path__ + "static/media/scventures.e45d5d25.jpeg";